import React from "react";
import {
  Table,
  SearchFilters,
  HeadingGroup,
  Pagination,
  OffCanvasLayout,
  ModalLayout,
  ConfirmationBox,
} from "@wac-ui-dashboard/wac_component_library";
import useBranchPincode from "./useBranchPincode";
import EmptyData from "../../../Global/EmptyData";
import { FaSort } from "react-icons/fa";
import PincodeForm from "./pincodeForm";

const BranchPincode = () => {
  const {
    mainData,
    menuState,
    hasEditPermission,
    hasCreatePermission,
    hasDeletePermission,
    isFetching,
    showCreateModal,
    showDeleteConfirm,
    handleEditClick,
    isLoading,
    currentPage,
    paginationOptions,
    selectedIds,
    handleSearch,
    handleActionChange,
    handleClearClick,
    handlePagination,
    handlePageSize,
    setShowDeleteConfirm,
    handleDelete,
    handleEditAction,
    handleSort,
    refetch,
    closeModal,
    handleCreateClick,
    handleDeleteAction,
    getRow,
    handleSelect,
  } = useBranchPincode();
  return (
    <>
      <HeadingGroup
        title={"Pincode"}
        extraClassName={`pro-pt-5`}
        buttonTitle={hasCreatePermission === 1 ? "Add new" : ""}
        handleClick={handleCreateClick}
      />
      <div className={`col-auto pro-pt-3 pro-pb-6`}>
        <div className="row">
          <div className="col">
            <SearchFilters
              data={mainData?.data?.filters}
              onSearchInput={handleSearch}
              showActions={false}
              handleActionClick={handleEditClick}
              loading={isLoading}
              SearchIcon={
                <span className="material-symbols-outlined"> search </span>
              }
              // actionOptions={actionOptions?.filter((item) => item.value === 0)}
              onActionOptionChange={handleActionChange}
              handleClear={handleClearClick}
              searchInputProps={{ value: menuState?.search }}
            />
          </div>
        </div>

        {mainData?.data?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            data={mainData?.data?.data?.data || []}
            uniqueID={"pincode_id"}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            showCheckBox={hasEditPermission === 1 ? true : false}
            deletable={hasDeletePermission === 1 ? true : false}
            editable={selectedIds?.ids?.length > 1 ? false : true}
            handleDelete={handleDelete}
            handleEdit={handleEditAction}
            clear={menuState?.clearSelection}
            multiSelect={true}
            assignable={false}
            fields={mainData?.data?.fields}
            SortIcon={<FaSort />}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            perpage={menuState?.currentPageSize}
            handleSelect={handleSelect}
          />
        )}

        {mainData?.data?.data?.data?.length > 0 && (
          <Pagination
            currentPage={currentPage}
            defaultValue={paginationOptions?.filter(
              (item) => item.value === menuState?.currentPageSize
            )}
            totalPageCount={mainData?.data?.data?.last_page}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}

        <OffCanvasLayout
          show={showCreateModal}
          handleClose={closeModal}
          title={menuState?.is_edit ? "Update Pincode" : "Add Pincode"}
          closeIcon={<span className="material-symbols-outlined">close</span>}
          backdrop="static"
        >
          <PincodeForm refetch={refetch} closeModal={closeModal} />
        </OffCanvasLayout>

        <ModalLayout
          centered={false}
          show={showDeleteConfirm}
          handleClose={setShowDeleteConfirm}
          backdrop="static"
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={`Are you sure you want to delete?`}
              isRight={true}
              cancelText={`No`}
              submitText={`Yes`}
              cancelAction={setShowDeleteConfirm}
              submitAction={handleDeleteAction}
            >
              ConfirmationBox
            </ConfirmationBox>

            {true && <span className="error-message">{true}</span>}
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default BranchPincode;
